"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var owa_options_core_1 = require("owa-options-core");
var store_1 = require("../store/store");
var owa_session_store_1 = require("owa-session-store");
var legacy_1 = require("satcheljs/lib/legacy");
var stitch_1 = require("satcheljs/lib/legacy/stitch");
var setIsFocusedCapableService_1 = require("../services/setIsFocusedCapableService");
var owa_analytics_1 = require("owa-analytics");
var saveFocusInboxOptionStitchName = 'saveFocusInboxOptionStitchName';
var saveFocusedInboxOption = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(legacy_1.action('saveFocusedInboxOption')(function saveFocusedInboxOption(isEnabledOverride, state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions, servicePromises;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    if (isEnabledOverride !== undefined) {
                        optionState.isEnabled = isEnabledOverride;
                    }
                    userOptions.IsFocusedInboxEnabled = optionState.isEnabled;
                    // Raise stitch so that, if we're running in mail, the focused inbox will toggle on and off
                    stitch_1.raiseAction(saveFocusInboxOptionStitchName)(userOptions.IsFocusedInboxEnabled);
                    servicePromises = [];
                    servicePromises.push(owa_options_core_1.updateUserConfiguration([
                        {
                            propertyName: 'IsFocusedInboxEnabled',
                            propertyType: 'Boolean',
                            propertyValue: "" + optionState.isEnabled,
                        },
                    ]));
                    // Make a request to set IsFocusedInboxCapable if IsFocusedInboxEnabled is set to true
                    if (userOptions.IsFocusedInboxEnabled) {
                        servicePromises.push(setIsFocusedCapableService_1.default());
                    }
                    return [4 /*yield*/, Promise.all(servicePromises)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
exports.default = saveFocusedInboxOption;
var OPTION_QUICK_SETTING_USAGE_KEY = 'QuickSettingFocusedInbox';
function saveFocusedInboxQuickOption(isEnabled) {
    owa_analytics_1.logUsage(OPTION_QUICK_SETTING_USAGE_KEY, ["" + isEnabled]);
    saveFocusedInboxOption(isEnabled);
}
exports.saveFocusedInboxQuickOption = saveFocusedInboxQuickOption;
//# sourceMappingURL=saveFocusedInboxOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-focused-option/lib/actions/saveFocusedInboxOption.js
// module id = 5088
// module chunks = 2